import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import App from './App';
/* import reportWebVitals from './reportWebVitals'; */
import './styles/index.scss';
import awsConfig from './utils/awsConfig';

const root = ReactDOM.createRoot(document.getElementById('root'));
awsConfig.amplifyConfig();
root.render(
  <BrowserRouter>
    <App />
    <Helmet>
      <link rel="canonical" href="https://www.rimac.com/comprar/seguro-salud-flexible" />
    </Helmet>
  </BrowserRouter>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
/* reportWebVitals(); */
